import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";

@Component({
    selector: 'menu-filter-modal',
    templateUrl: './menu-filter-modal.component.html',
    standalone: false

})
export class MenuFilterModalComponent implements OnInit {
    filteredMenus: any[] = [];

    constructor(private activeModal: NgbActiveModal, private router: Router) {}

    ngOnInit(): void {}

    closeModal() {
        this.activeModal.dismiss();
    }

    navigate(menuItem: any) {
        if (menuItem.url) {
            this.router.navigate([menuItem.url]);
            this.activeModal.close(menuItem);
        }
    }
}
